import {connect} from 'react-redux';
import {AnimationSequence as Component} from './AnimationSequence';
import {
  showModal,
  setModal,
  incSolution,
  decSolution,
  setGlassTubepH,
  setRun12hours,
  rotateCuvette,
  holdCuvette
  // setSolutionMixed,
  // prepareGelBox,
  // runGel,
  // visualizeGel,
  // loadDNALadder,
  // putOnPPE,
  // runThermocycler
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {
  return {
    taskPages: state.notebook.protocolSection.scene.taskPages,
    solutions: state.notebook.protocolSection.scene.apparatus.solutions,
    glassTubes: state.notebook.protocolSection.scene.apparatus.glassTubes,
    light: state.notebook.protocolSection.scene.apparatus.light,
    tableData: state.notebook.protocolSection.tableData
  }
}

function mapDispatchToProps(dispatch) {
  return {
    showModal: (data) => {
      dispatch(showModal(data))
    },
    setModal: (data) => {
      dispatch(setModal(data))
    },
    incSolution: (data) => {
      dispatch(incSolution(data))
    },
    decSolution: (data) => {
      dispatch(decSolution(data))
    },
    setGlassTubepH: (data) => {
      dispatch(setGlassTubepH(data))
    },
    setRun12hours: (data) => {
      dispatch(setRun12hours(data))
    },
    rotateCuvette: (data) => {
      dispatch(rotateCuvette(data))
    },
    holdCuvette: (data) => {
      dispatch(holdCuvette(data))
    },
    // setSolutionMixed: (data) => {
    //   dispatch(setSolutionMixed(data))
    // },
    // prepareGelBox: (data) => {
    //   dispatch(prepareGelBox(data))
    // },
    // runGel: (data) => {
    //   dispatch(runGel(data))
    // },
    // visualizeGel: (data) => {
    //   dispatch(visualizeGel(data))
    // },
    // loadDNALadder: (data) => {
    //   dispatch(loadDNALadder(data))
    // },
    // putOnPPE: (data) => {
    //   dispatch(putOnPPE(data))
    // },
    // runThermocycler: (data) => {
    //   dispatch(runThermocycler(data))
    // }
  };
}

export const AnimationSequence = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
